import { apiDocsTranslation } from './apiDocs';
import { catalogTranslation } from './catalog';
import { catalogGraphTranslation } from './catalogGraph';
import { coreComponentsTranslation } from './coreComponents';
import { notificationsTranslation } from './notifications';
import { orgTranslation } from './org';
import { scaffolderTranslation } from './scaffolder';
import { searchTranslation } from './search';
import { techdocsTranslation } from './techdocs';
import { userSettingsTranslation } from './userSettings';
import { catalogReactTranslation } from './catalogReact';
import { scaffolderReactTranslation } from './scaffolderReact';
import { searchReactTranslation } from './searchReact';

export const dutchTranslations = [
  catalogReactTranslation,
  scaffolderReactTranslation,
  searchReactTranslation,
  apiDocsTranslation,
  catalogTranslation,
  catalogGraphTranslation,
  coreComponentsTranslation,
  notificationsTranslation,
  orgTranslation,
  scaffolderTranslation,
  searchTranslation,
  techdocsTranslation,
  userSettingsTranslation,
];
